declare namespace $ {

	export class $mol_icon_target extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=target.view.tree.d.ts.map